import React from 'react';
import {
  DefaultNotification,
  IDefaultNotificationProps,
} from '../../DefaultNotification';

function CreateSubscriptionNotification(
  notification: IDefaultNotificationProps,
) {
  return <DefaultNotification {...notification} />;
}

export default CreateSubscriptionNotification;
